import request, { ResponseData, PagerData } from '@/libs/request/request'
import { GenealogyQuery } from 'src/api/genealogy/GenealogyQuery'
import { Village } from 'src/api/village/Village'
import { MakeGenealogy } from 'src/api/genealogy/MakeGenealogy'
import { ElectronicGenealogyDonationList } from 'src/api/electronic/ElectronicGenealogyDonationList'
import { GenealogyChoose } from '@/api/genealogy/GenealogyChoose'

// Genealogy
export type Genealogy = {

  // 族谱联系人
  contacts?:string

  createBy?:number

  createByName?:string

  // 创建时间
  createTime?:string

  // 业务Id
  id?:number

  // imageUrl
  imageUrl?:string

  // introduction
  introduction?:string

  // 轮播图场景名称
  name?:string

  // 手机号
  phone?:string

  // 姓氏
  surname?:string

  updateBy?:number

  updateByName?:string

  // 更新时间
  updateTime?:string

  // 标题
  version?:number

  // 村庄
  village?:Village

  // 村庄id
  villageId?:number

  // 村庄名
  villageName?:string

  // 创建类型 0:平台创建 1:用户创建
  createType?:number

  electronicGenealogyDonationList?:ElectronicGenealogyDonationList

  // 是否删除 0:否 1:是
  isDeleted?:number

  // 是否禁用
  delFlag?:number
}

export default class GenealogyService {
  /**
   * 创建一个族谱
   * @param {MakeGenealogy} makeGenealogy 族谱实体
   **/
  static addOneGenealogy (makeGenealogy?:MakeGenealogy):Promise<ResponseData<boolean>> {
    return request<ResponseData<boolean>>({
      method: 'POST',
      data: makeGenealogy,
      url: '/admin/Genealogy/Genealogy'
    })
  }

  /**
   * 更新一个族谱
   * @param {Genealogy} item 族谱实体
   **/
  static updateOneGenealogy (item?:Genealogy):Promise<ResponseData<Genealogy>> {
    return request<ResponseData<Genealogy>>({
      method: 'PUT',
      data: item,
      url: '/admin/Genealogy/Genealogy'
    })
  }

  /**
   * 获取族谱的分页数据
   * @param {GenealogyQuery} query 族谱实体查询条件
   **/
  static getPagesOfGenealogy (query?:GenealogyQuery):Promise<ResponseData<PagerData<Genealogy>>> {
    return request<ResponseData<PagerData<Genealogy>>>({
      method: 'POST',
      data: query,
      url: '/admin/Genealogy/Genealogy/pages'
    })
  }

  /**
   * 通过id获取一个族谱
   * @param {number} id 族谱id
   **/
  static getOneGenealogy (id:number):Promise<ResponseData<Genealogy>> {
    return request<ResponseData<Genealogy>>({
      method: 'GET',
      url: `/admin/Genealogy/Genealogy/${id}`
    })
  }

  /**
   * 删除一个族谱(软删除，即将isDelete赋值1)
   * @param {number} id 族谱id
   **/
  static deleteOneGenealogy (id:number):Promise<ResponseData<boolean>> {
    return request<ResponseData<boolean>>({
      method: 'DELETE',
      url: `/admin/Genealogy/Genealogy/${id}`
    })
  }

  /**
   * 将一个用户移出族谱
   * @param {number} genealogyId 族谱id
   * @param {number} userId 用户id
   **/
  static removeUser (genealogyId:number, userId:number):Promise<ResponseData<string>> {
    return request<ResponseData<string>>({
      method: 'DELETE',
      url: `/admin/Genealogy/Genealogy/removeUser/${genealogyId}/${userId}`
    })
  }

  /**
   * 获取没有绑定村子的族谱列表
   **/
  static getnullOfGenealogy ():Promise<ResponseData<Array<Genealogy>>> {
    return request<ResponseData<Array<Genealogy>>>({
      method: 'GET',
      url: '/admin/Village/GenealogyList/'
    })
  }

  /**
   * 通过村子ID和族谱ID进行绑定
   * @param {number} genealogyId 族谱id
   * @param {number} villageId 村庄id
   **/
  static bindVillage (genealogyId:number, villageId:number):Promise<ResponseData<Genealogy>> {
    return request<ResponseData<Genealogy>>({
      method: 'PUT',
      url: `/admin/Village/GenealogyList/${villageId}/${genealogyId}`
    })
  }

  /**
   * 通过村子ID和族谱ID删除绑定关系
   * @param {number} genealogyId 族谱id
   * @param {number} villageId 村庄id
   **/
  static freeBindVillage (genealogyId:number, villageId:number):Promise<ResponseData<Genealogy>> {
    return request<ResponseData<Genealogy>>({
      method: 'DELETE',
      url: `/admin/Village/GenealogyList/${villageId}/${genealogyId}`
    })
  }

  /**
   * 根据村子ID获取所有关联的族谱列表
   * @param {number} villageId 村庄id
   **/
  static getPagesOfGenealogyByViliageId (villageId:number):Promise<ResponseData<Array<Genealogy>>> {
    return request<ResponseData<Array<Genealogy>>>({
      method: 'GET',
      url: `/admin/Village/GenealogyList/${villageId}`
    })
  }

  /**
   * 获取族谱的分页数据
   * @param {GenealogyQuery} query 族谱实体查询条件
   **/
  static getPagesOfGenealogyFamily (query?:GenealogyQuery):Promise<ResponseData<PagerData<Genealogy>>> {
    return request<ResponseData<PagerData<Genealogy>>>({
      method: 'POST',
      data: query,
      url: '/admin/Genealogy/GenealogyFamily/pages'
    })
  }

  /**
   * 修改族谱状态
   * @param choose
   */
  static genealogyChoose (choose?:GenealogyChoose):Promise<ResponseData<string>> {
    return request<ResponseData<string>>({
      method: 'POST',
      data: choose,
      url: '/admin/Genealogy/GenealogyFamily/choose'
    })
  }
}
